import { render, staticRenderFns } from "./CostBreakdown.vue?vue&type=template&id=942674c4&scoped=true"
import script from "./CostBreakdown.vue?vue&type=script&lang=js"
export * from "./CostBreakdown.vue?vue&type=script&lang=js"
import style0 from "./CostBreakdown.vue?vue&type=style&index=0&id=942674c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942674c4",
  null
  
)

export default component.exports